import $ from 'jquery';

var ProductsFilters = {
    selectors: {
        range_slider_text_input: $('.filter-range-text-input'),
        range_slider_text_input_from: $('.range-text-input-min'),
        range_slider_text_input_to: $('.range-text-input-max'),
        products_filters_form: $('#products-filters-form'),
        products_view_changers: $('.filters-view-changer'),
        products_sort_changer: $('#sort-by'),
        products_view_wrappers: $('.products__content-products-wrapper'),
        products_filters_toggler: $('#toggleFilters'),
        products_filters_close: $('#closeFilters')
    },

    init: function () {
        this.eventsHandler();
    },

    eventsHandler: function () {
        var selectors = this.selectors;

        this.productsViewChangeHandler();

        this.productsPageSizeChangeHandler();

        this.productsSortChangeHandler();

        this.mobileFiltersHandler();

        this.productFiltersFormHandler();

        selectors.products_filters_form.submit(function (e) {
            e.preventDefault();
            ProductsFilters.submitFiltersForm(this);
        })
    },

    submitFiltersForm: function (form) {
        const formData = $(form).serializeArray();
        const uri = new URI();
        const currentQuery = uri.query(true);
        const queryObject = {};
        const $form = this.selectors.products_filters_form;

        if (currentQuery.cat) {
            queryObject.cat = currentQuery.cat;
        }

        if (currentQuery.view) {
            queryObject.view = currentQuery.view;
        }

        if (currentQuery.per_page) {
            queryObject.per_page = currentQuery.per_page;
        }

        if (currentQuery.sort_by) {
            queryObject.sort_by = currentQuery.sort_by;
        }

        formData.forEach(function(field){
            if (/^(filter)/.test(field.name)) {

                if (field.name.indexOf('toggle') !== -1 && field.value == 'all') {
                    return;
                }

                if (!queryObject.hasOwnProperty(field.name)) {
                    if (/\[]$/.test(field.name)) {
                        queryObject[field.name] = [field.value];
                    } else {
                        queryObject[field.name] = field.value;
                    }
                } else if (/\[]$/.test(field.name) && queryObject[field.name].indexOf(field.value) === -1) {
                    queryObject[field.name].push(field.value);
                }
            }
        });

        $form.find('.products__sidebar-filter--range .irs-hidden-input').each(function (i, el) {
            const defaultMin = parseFloat($(el).attr('data-min'));
            const defaultMax = parseFloat($(el).attr('data-max'));
            const filter = $(el).attr('name').substr(8);

            if (parseFloat(queryObject[`${filter}[min]`]) === defaultMin && parseFloat(queryObject[`${filter}[max]`]) === defaultMax) {
                delete queryObject[`${filter}[min]`];
                delete queryObject[`${filter}[max]`];
            }
        });

        const newUri = new URI(uri.origin() + uri.path());
        newUri.setQuery(queryObject);

        location.href = newUri.href();
    },

    productsViewChangeHandler: function () {
        this.selectors.products_view_changers.click(function() {
            const uri = new URI();

            if ($(this).data('view') == 'list') {
                uri.setQuery('view', 'list');
            } else {
                uri.removeQuery('view');
            }
            location.href = uri.href();
        });
    },

    productsSortChangeHandler: function () {
        this.selectors.products_sort_changer.change(function () {
            const uri = new URI();

            if ($(this).val() == 'price' || $(this).val() == 'date' || $(this).val() == 'code' || $(this).val() == 'most_ordered') {
                uri.setQuery('sort_by', $(this).val());
            } else {
                uri.removeQuery('sort_by');
            }
            location.href = uri.href();
        });
    },

    productsPageSizeChangeHandler: function () {
        $('#products-per-page').change(function () {
            const uri = new URI();
            uri.setQuery('per_page', $(this).val());
            uri.setQuery('page', 1);
            location.href = uri.href();
        });
    },

    mobileFiltersHandler: function () {
        var selectors = this.selectors;

        selectors.products_filters_toggler.click(function() {
            var filtersContainer = $(`#${$(this).data('toggle')}`);

            filtersContainer.addClass('products__sidebar-filters-revealed');
            $('body').css('overflow', 'hidden');
        });

        selectors.products_filters_close.click(function () {
            var filtersContainer = $(`#${$(this).data('toggle')}`);

            filtersContainer.removeClass('products__sidebar-filters-revealed');
            $('body').css('overflow', '');
        });

        $(window).resize(function() {
            if ($(window).width() > 991) {
                var filtersContainer = $('#productsFilters');

                filtersContainer.removeClass('products__sidebar-filters-revealed');
                $('body').css('overflow', '');

                selectors.products_filters_close.parent().removeClass('close-filters-wrapper--fixed');
            }
        });

        $('#productsFilters').bind('scroll', function () {
            var filtersContainer = $(this);
            if (filtersContainer.hasClass('products__sidebar-filters-revealed')) {
                if (filtersContainer.scrollTop() > 20) {
                    selectors.products_filters_close.parent().addClass('close-filters-wrapper--fixed');
                } else {
                    selectors.products_filters_close.parent().removeClass('close-filters-wrapper--fixed');
                }
            }
        });
    },

    productFiltersFormHandler: function () {
        const $form = this.selectors.products_filters_form;

        this.selectors.products_filters_form.find('.filter-input').not($('.filter-range-text-input')).on('change', function (e) {
            $form.submit();
        });

        this.selectors.products_filters_form.find('.filter-range-btn').on('click', function(e){
            $form.submit();
        });

        $('#clearAppliedFilters').click(function () {
            const uri = new URI();
            const currentQuery = uri.query(true);
            const queryObject = {};

            if (currentQuery.cat) {
                queryObject.cat = currentQuery.cat;
            }

            if (currentQuery.view) {
                queryObject.view = currentQuery.view;
            }

            if (currentQuery.per_page) {
                queryObject.per_page = currentQuery.per_page;
            }

            if (currentQuery.sort_by) {
                queryObject.sort_by = currentQuery.sort_by;
            }

            const newUri = new URI(uri.origin() + uri.path());
            newUri.setQuery(queryObject);

            location.href = newUri.href();
        });
    }
}

export default ProductsFilters;
